// extracted by mini-css-extract-plugin
module.exports = {"prefooter":"sKK8","promotion":"s16a","promotionText":"s1N-","promotionLinks":"sw1F"};